import { createContext, useContext } from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';

interface AnalyticsContextValue {
  trackClick: (eventName: string, metadata?: Record<string, any>) => void;
  trackFunnelStep: (funnelName: string, stepNumber: number, stepName: string) => void;
}

const AnalyticsContext = createContext<AnalyticsContextValue>({
  trackClick: () => {},
  trackFunnelStep: () => {},
});

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const analytics = useAnalytics();
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export function useAnalyticsContext() {
  return useContext(AnalyticsContext);
}
